
function PageNumber($, totalPageNumber){
	var me = this;

	me.changed = function( currentPage ){
		$('.pageNumber .currentPageNumber').html( currentPage );
	};

	me.onReady = function(totalPageNumber){
		$('.totalPageNumber').html(totalPageNumber);
	};
	me.onReady(totalPageNumber);
}

